import { render, staticRenderFns } from "./SiteAppUserFeedback.vue?vue&type=template&id=7b64c24a&scoped=true&"
import script from "./SiteAppUserFeedback.vue?vue&type=script&lang=js&"
export * from "./SiteAppUserFeedback.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppUserFeedback.vue?vue&type=style&index=0&id=7b64c24a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b64c24a",
  null
  
)

export default component.exports